<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Personal Information</span>
        </div>

        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" label="Username" v-model="data_local.username" name="Username" v-validate="'required|alpha_dash'" />
          <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>

          <vs-input class="w-full mt-4" label="First Name" v-model="data_local.firstname" name="First Name" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>

          <vs-input class="w-full mt-4" label="Last Name" v-model="data_local.lastname" name="Last Name" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>

          <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" name="Email" v-validate="'required|email'" />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>

          <vs-input class="w-full mt-4" label="Mobile" v-model="data_local.mobile" name="Mobile" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>

          <vs-input class="w-full mt-4" label="Omma License Number" v-model="data_local.omma_license_number" name="Omma License Number" />
        </div>
      </div>

      <!-- Address Col -->
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end md:mt-0 mt-base">
          <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Address</span>
        </div>

        <!-- Col Content -->

        <vs-input class="w-full mt-4" label="Business Name" v-model="data_local.business_name" name="Business Name" />

        <vs-input class="w-full mt-4" label="Address" v-model="data_local.address" />

        <div class="w-full mt-4">
          <label>City</label>
          <select-2 :ssr="false" label="City" :value="data_local.cityId" @input="(item) => (data_local.cityId = item && item.value)" name="City" placeholder="City" action="getCityOptions" />
        </div>

        <vs-input class="w-full mt-4" label="State" v-model="data_local.state" name="State" />

        <vs-input class="w-full mt-4" label="Zip Code" v-model="data_local.zipcode" name="Zip Code" />

        <vs-input v-validate="'alpha_dash'" data-vv-validate-on="blur" label="Metrc API Key" name="metrcKey" placeholder="Metrc API key" v-model="data_local.metrcKey" class="w-full mt-4" />
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2 vs-con-loading__container" id="edit-user-button" type="relief" @click="save_changes" :disabled="!validateForm || processing">Save Changes</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  data() {
    return {
      data_local: { ...this.data },
      processing: false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  mounted() {},
  methods: {
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      this.processing = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#edit-user-button',
        scale: 0.45
      })
      try {
        const { message } = await this.$store.dispatch('auth/updateProfile', this.data_local)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      this.processing = false
      this.$vs.loading.close('#edit-user-button > .con-vs-loading')
    }
  },
  components: {
    Select2
  }
}
</script>